<form *ngIf="stdInputFormGroup" [formGroup]="stdInputFormGroup" class="flange-form-main">
    <app-standard [form]="stdInputFormGroup" [enable]="enable" (defaultBoltType)="setBoltType($event)"></app-standard>

    <app-pressure-class [form]="stdInputFormGroup" [standardId]="standardId" [enable]="enable"></app-pressure-class>

    <!-- here min and max pipe sze for only pipecodes in iDMS Settings -->
    <app-min-max-pipe-size *ngIf="router.url == '/settings/idms'"
                           [enable]="enable"
                           [form]="stdInputFormGroup"
                           [pressureClassId]="pressureClassId"
                           [enable]="enable"
                           class="flange-inner-form"></app-min-max-pipe-size>

    <app-pipe-size *ngIf="router.url != '/settings/idms'" [form]="stdInputFormGroup" [pressureClassId]="pressureClassId" [enable]="enable"></app-pipe-size>

    <app-flange-type [form]="stdInputFormGroup"
                     [standardId]="standardId"
                     [pressureClassId]="pressureClassId"
                     [pipeSizeId]="pipeSizeId"
                     [isCustom]="isCustom"
                     [enable]="enable"></app-flange-type>

    <app-flange-facing-type [form]="stdInputFormGroup"
                            [flangeTypeId]="flangeTypeId"
                            [pressureClassId]="pressureClassId"
                            [pipeSizeId]="pipeSizeId"
                            [enable]="enable"></app-flange-facing-type>

    <app-flange-material class="input-wrapper-list"
                         [form]="stdInputFormGroup"
                         [enable]="enable"
                         [standardId]="standardId"
                         [doFlangeMaterialReset]="doFlangeMaterialReset"
                         [enable]="enable"></app-flange-material>

    <app-gasket [form]="stdInputFormGroup"
                class="input-wrapper-list"
                [standardId]="standardId"
                [flangeFacingTypeId]="flangeFacingTypeId"
                [pressureClassId]="pressureClassId"
                [pipeSizeId]="pipeSizeId"
                [isStandardFlange]="isStandardFlange"
                [isRTJ]="isRTJ"
                [doGasketReset]="doGasketReset"
                [enable]="enable"></app-gasket>

    <app-bolt-type [form]="stdInputFormGroup" (selected)="onSelectedBoltType($event)" [enable]="enable"></app-bolt-type>

    <app-bolt-material [form]="stdInputFormGroup"
                       [enable]="enable"
                       class="input-wrapper-list"
                       [standardId]="standardId"
                       [doBoltMaterialReset]="doBoltMaterialReset"
                       [enable]="enable"></app-bolt-material>

    <app-tightening-specification [calculationType]="calculationType" [form]="stdInputFormGroup" [enable]="enable"></app-tightening-specification>

    <app-pipe-schedule style="width: 100%" *ngIf="router.url == '/settings/idms'" [form]="stdInputFormGroup" [enable]="enable"></app-pipe-schedule>

    <div class="box-div" *ngIf="router.url != '/settings/idms'">
        
        <app-advance-options *ngIf="router.url != '/settings/idms'" [form]="stdInputFormGroup"></app-advance-options>

        <div *ngIf="stdInputFormGroup.get('enableAdvOp').value == true" style="width: 100%" class="box-child-div">
            <app-flange-type2 [form]="stdInputFormGroup"
                              [standardId]="standardId"
                              [pressureClassId]="pressureClassId"
                              [pipeSizeId]="pipeSizeId"
                              [isCustom]="isCustom"
                              [defaultFlangeTypeId]="flangeTypeId"></app-flange-type2>



            <app-pipe-schedule [form]="stdInputFormGroup" [pipeSizeId]="pipeSizeId"></app-pipe-schedule>

            <app-washers [form]="stdInputFormGroup" [boltType]="boltType" [pressureClassId]="pressureClassId" [pipeSizeId]="pipeSizeId"></app-washers>

            <app-additional-component [form]="stdInputFormGroup" [pressureClassId]="pressureClassId" [pipeSizeId]="pipeSizeId"></app-additional-component>
        </div>
    </div>

    <div class="box-div" *ngIf="idmsSharedService.enableConfirmWithRouter(1) && isOverrideFlange">
        <app-override-flange [form]="stdInputFormGroup"></app-override-flange>

        <div *ngIf="stdInputFormGroup.get('enableOveride').value == true" style="width: 100%" class="box-child-div">
            <app-thread-type-bolt-size [form]="stdInputFormGroup" [boltType]="boltType"></app-thread-type-bolt-size>

            <app-bolt-quantity [form]="stdInputFormGroup"></app-bolt-quantity>

            <app-reduced-area-bolting [form]="stdInputFormGroup"></app-reduced-area-bolting>

            <app-nut-standard [form]="stdInputFormGroup" [boltDimensionId]="boltDimensionId"></app-nut-standard>

            <app-rec-gasket-stress [form]="stdInputFormGroup"></app-rec-gasket-stress>

            <app-min-gasket-stress [form]="stdInputFormGroup"></app-min-gasket-stress>

            <app-max-gasket-stress [form]="stdInputFormGroup"></app-max-gasket-stress>

            <app-y [form]="stdInputFormGroup"></app-y>

            <app-m [form]="stdInputFormGroup"></app-m>

            <div *ngIf="tighteningMethod == 1">
                <app-padditional [form]="stdInputFormGroup"></app-padditional>
            </div>
        </div>
    </div>
   
    <div *ngIf="idmsSharedService.enableConfirmWithRouter(1)">
        <a href="javascript:void(0)" class="btn font-weight-bold py-3 px-6 secondary-ebtn informateFullWidth" (click)="btnStdInputConfirmClicked()">
            <!-- Confirm -->
            {{ 'STANDARD_FLANGE_PAGE.BUTTONS_TEXT.CONFIRM' | transloco }}
        </a>
    </div>
</form>
